import { fmtDateBoth } from './dates';
import { fmtMoney } from './money';

const STATUS_AR = {
  draft: 'مسودة', issued: 'صادرة', paid: 'مدفوعة', cancelled: 'ملغاة',
};

// يفتح نافذة طباعة بفاتورة منسّقة (A4) ثم يستدعي حوار الطباعة تلقائياً.
export function printInvoice(invoice, projectTitle) {
  const win = window.open('', '_blank', 'width=900,height=700');
  if (!win) return;

  const items = invoice.items || [];
  const clientName = invoice.project?.client?.name || invoice.project?.sponsor?.name || '';
  const discount = Number(invoice.discount) || 0;
  const taxRate = Number(invoice.tax_rate) || 0;

  const rows = items.map(it => `
    <tr>
      <td>${escapeHtml(it.name)}</td>
      <td>${escapeHtml(it.unit || '—')}</td>
      <td>${fmtMoney(it.quantity)}</td>
      <td>${fmtMoney(it.unit_price)}</td>
      <td>${fmtMoney((Number(it.quantity) || 0) * (Number(it.unit_price) || 0))}</td>
    </tr>`).join('');

  const html = `<!doctype html>
<html lang="ar" dir="rtl">
<head>
<meta charset="utf-8">
<title>فاتورة ${escapeHtml(invoice.invoice_number)}</title>
<style>
  @page { size: A4; margin: 15mm; }
  @font-face { font-family: 'Tajawal'; src: url('/fonts/tajawal/Tajawal-Regular-arabic.woff2') format('woff2'); font-weight: 400; }
  @font-face { font-family: 'Tajawal'; src: url('/fonts/tajawal/Tajawal-Bold-arabic.woff2') format('woff2'); font-weight: 700; }
  @font-face { font-family: 'Tajawal'; src: url('/fonts/tajawal/Tajawal-Black-arabic.woff2') format('woff2'); font-weight: 900; }
  body { font-family: 'Tajawal', 'Arial', sans-serif; direction: rtl; color: #1A2330; line-height: 1.9; margin: 0; padding: 20px; }
  .header { display: flex; justify-content: space-between; align-items: flex-start;
    padding-bottom: 12px; border-bottom: 1px solid #E6E9EF; margin-bottom: 20px; }
  .header .kicker { font-size: 12px; color: #6B7686; letter-spacing: 0.04em; margin-bottom: 4px; }
  .header h1 { margin: 0; font-size: 24px; font-weight: 900; color: #143A67; }
  .meta { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; font-size: 13px; margin-bottom: 20px; }
  .meta .label { color: #6B7686; margin-inline-end: 6px; }
  table { width: 100%; border-collapse: collapse; font-size: 13px; margin-bottom: 16px; }
  th, td { text-align: right; padding: 8px 10px; border: 1px solid #E6E9EF; }
  th { background: #143A67; font-weight: 700; color: #fff; }
  tr:nth-child(even) td { background: #FAFCFE; }
  .totals { width: 320px; margin-inline-start: auto; font-size: 14px; }
  .totals .row { display: flex; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #E6E9EF; }
  .totals .grand { font-weight: 900; font-size: 16px; color: #143A67; border-top: 2px solid #143A67; border-bottom: none; margin-top: 4px; padding-top: 10px; }
  .notes { margin-top: 20px; font-size: 12px; color: #3A4452; white-space: pre-wrap; }
  .badge { display: inline-block; padding: 2px 12px; border-radius: 999px; font-size: 12px; font-weight: 700; background: #EAF2F8; color: #02537D; }
  .footer { margin-top: 40px; font-size: 10px; color: #6B7686; border-top: 1px solid #E6E9EF; padding-top: 6px; }
  @media print { body { padding: 0; } .no-print { display: none; }
    th, .badge { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
  .print-btn { position: fixed; top: 10px; left: 10px; padding: 10px 20px; background: #0E477A;
    color: white; border: none; border-radius: 10px; cursor: pointer; font-family: inherit; font-size: 14px; font-weight: 700; }
</style>
</head>
<body>
<button class="no-print print-btn" onclick="window.print()">🖨 طباعة / حفظ PDF</button>
<div class="header">
  <div>
    <div class="kicker">منصة العمليات</div>
    <h1>فاتورة</h1>
  </div>
  <div style="text-align: left;">
    <div style="font-size: 15px; font-weight: 700;">${escapeHtml(invoice.invoice_number)}</div>
    <div class="badge">${escapeHtml(STATUS_AR[invoice.status] || invoice.status)}</div>
  </div>
</div>
<div class="meta">
  <div><span class="label">المشروع:</span>${escapeHtml(projectTitle || invoice.project?.title || '')}</div>
  <div><span class="label">العميل / الجهة:</span>${escapeHtml(clientName)}</div>
  <div><span class="label">تاريخ الإصدار:</span>${escapeHtml(fmtDateBoth(invoice.issue_date))}</div>
  <div><span class="label">تاريخ الاستحقاق:</span>${invoice.due_date ? escapeHtml(fmtDateBoth(invoice.due_date)) : '—'}</div>
</div>
<table>
  <thead>
    <tr><th>الخدمة</th><th>الوحدة</th><th>الكمية</th><th>سعر الوحدة</th><th>الإجمالي</th></tr>
  </thead>
  <tbody>${rows || '<tr><td colspan="5" style="text-align:center;color:#6B7686;">لا توجد بنود</td></tr>'}</tbody>
</table>
<div class="totals">
  <div class="row"><span>المجموع الفرعي</span><span>${fmtMoney(invoice.subtotal)} ريال</span></div>
  ${discount > 0 ? `<div class="row"><span>الخصم</span><span>- ${fmtMoney(discount)} ريال</span></div>` : ''}
  ${taxRate > 0 ? `<div class="row"><span>الضريبة (${fmtMoney(taxRate)}%)</span><span>${fmtMoney(invoice.tax_amount)} ريال</span></div>` : ''}
  <div class="row grand"><span>الإجمالي</span><span>${fmtMoney(invoice.total)} ريال</span></div>
</div>
${invoice.notes ? `<div class="notes"><strong>ملاحظات:</strong> ${escapeHtml(invoice.notes)}</div>` : ''}
<div class="footer">منصة العمليات — فاتورة ${escapeHtml(invoice.invoice_number)}</div>
<script>window.addEventListener('load', () => setTimeout(() => window.print(), 300));</script>
</body>
</html>`;

  win.document.open();
  win.document.write(html);
  win.document.close();
}

function escapeHtml(s) {
  if (s == null) return '';
  return String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}
